import React, { useMemo } from "react";
import { Document, Page, Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";

Font.register({
    family: 'Poppins',
    fonts: [
        {
            src: '/fonts/Poppins-Regular.ttf',
            fontWeight: 'normal',
        },
        {
            src: '/fonts/Poppins-SemiBold.ttf',
            fontWeight: 600,
        },
        {
            src: '/fonts/Poppins-Bold.ttf',
            fontWeight: 'bold',
        },
    ],
});

// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 20,
    },
    col: {
        display: "flex",
        flexDirection: "row",
        // border: "1px solid black",
    }
});


const CollegeFollowUp = ({ data }) => {

    const studentdata = Array.isArray(data) ? data : [];

    const estimateRowHeight = (row) => {
        const discussion = row.discussion || "";
        const email = row.Email || "";

        const baseHeight = 80;

        const discussionLines = Math.ceil(discussion.length / 100); // adjust per font size
        const emailLines = Math.ceil(email.length / 35);

        const extraHeight = (discussionLines + emailLines) * 20;

        return baseHeight + extraHeight;
    };

    const chunkByEstimatedHeight = (data, pageHeight = 720) => {
        const pages = [];
        let currentPage = [];
        let currentHeight = 0;

        for (const row of data) {
            const rowHeight = estimateRowHeight(row);

            // If row is too big to fit on current page, push to new page
            if (rowHeight > pageHeight) {
                if (currentPage.length) {
                    pages.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                pages.push([row]); // row gets full page
                continue;
            }

            // If current row overflows page height, start new page
            if (currentHeight + rowHeight > pageHeight) {
                pages.push(currentPage);
                currentPage = [row];
                currentHeight = rowHeight;
            } else {
                currentPage.push(row);
                currentHeight += rowHeight;
            }
        }

        if (currentPage.length > 0) {
            pages.push(currentPage);
        }

        return pages;
    };


    // In your component
    const pages = useMemo(() => chunkByEstimatedHeight(studentdata), [studentdata]);

    function formatDate(dateInput) {
        const date = new Date(dateInput);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }
    return (
        <Document>

            {pages.map((pageData, pageIndex) => (
                <Page size="A4" orientation="landscape" style={{ padding: 30, fontSize: 10, }}>

                    <View style={[styles.row, { textAlign: "center", fontSize: "10px", borderLeft: "1px solid black", borderRight: "1px solid black", borderBottom: "1px solid black" }]}>
                        <View style={{ width: "100%", textAlign: "center", borderBottom: "1px solid black", borderTop: "1px solid black" }}>
                            <Text style={{ fontFamily: "Poppins", fontWeight: "bold" }}>COLLEGE FOLLOW UP REPORT FROM :</Text>
                        </View>

                        <View style={[styles.col, { borderBottom: "1px solid black" }]}>
                            <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Date</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Disciplaine</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "30%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Company Name</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "30%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Contact Person</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Mobile</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "30%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>E-mail</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Direct Line</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Designation</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Purpose</Text>
                            </View>
                            <View style={{ width: "30%" }}>
                                <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", fontWeight: "bold" }}>Remark</Text>
                            </View>
                        </View>

                        {pageData.map((item, i) => (
                            <View style={[styles.col, { borderBottom: "1px solid black" }]}>
                                <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{formatDate(item.Tdate)}</Text>
                                </View>
                                <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{item.Discipline}</Text>
                                </View>
                                <View style={{ borderRight: "1px solid black", width: "30%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{item.college_name}</Text>
                                </View>
                                <View style={{ borderRight: "1px solid black", width: "30%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{item.CName}</Text>
                                </View>
                                <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{item.Phone}</Text>
                                </View>
                                <View style={{ borderRight: "1px solid black", width: "30%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{item.Email}</Text>
                                </View>
                                <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{item.DirectLine}</Text>
                                </View>
                                <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{item.Designation}</Text>
                                </View>
                                <View style={{ borderRight: "1px solid black", width: "20%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{item.Purpose}</Text>
                                </View>
                                <View style={{ width: "30%" }}>
                                    <Text style={{ textAlign: "center", fontSize: 10, fontFamily: "Poppins", }}>{item.Remark}</Text>
                                </View>
                            </View>
                        ))}


                    </View>

                </Page>
            ))}
        </Document>



    )
}

export default CollegeFollowUp